<script lang="ts" setup>
import type { PitchDistance, PitchPosition } from './types'

type Props = {
  d: string
  distance: PitchDistance
  position: PitchPosition
  baseFillClass: string
  stroke?: string
  strokeWidth?: string | number
  strokeDasharray?: string
  selected?: boolean
}

type Emits = {
  (e: 'click', distance: PitchDistance, position: PitchPosition): void
}

const props = withDefaults(defineProps<Props>(), {
  selected: false,
})

const emit = defineEmits<Emits>()

function handleClick(): void {
  emit('click', props.distance, props.position)
}
</script>

<template>
  <path
    :class="[
      'cursor-pointer',
      baseFillClass,
      { 'fill-[rgba(0,147,216,1)]!': selected },
    ]"
    :d
    :stroke
    :stroke-width
    :stroke-dasharray
    @click="handleClick"
  />
</template>
